import AppProvider from './AppContext'
import { BrowserRouter } from 'react-router-dom'

const Contexts = ({ children }) => {
    return <BrowserRouter basename={''}>
        <AppProvider>{children}</AppProvider>
    </BrowserRouter>
}
export default Contexts